
<!-- [style.transform]="'translate3d(' + x + 'px, ' + y + 'px, 50px)'" -->
<div
  id="box"
  *ngIf="signImage"
  #box
  class="all-scroll"
  [style.width.px]="width"
  [style.height.px]="height"
  
  cdkDrag
  [cdkDragFreeDragPosition]="dragPosition"
  cdkDragBoundary=".section-1"
  (cdkDragEnded)="dragEndOfDropedItems($event)"
>
  <img [src]="signImage" alt="" />
  <div
    (mousedown)="onCornerClick($event, topLeftResize)"
    (touchstart)="onCornerTouchStart($event, topLeftResize)"
    id="box-top-left-resize"
    class="box-corner-resize resize-action"
  ></div>
  <div
    (mousedown)="onCornerClick($event, topRightResize)"
    (touchstart)="onCornerTouchStart($event, topRightResize)"
    id="box-top-right-resize"
    class="box-corner-resize resize-action"
  ></div>
  <div
    (mousedown)="onCornerClick($event, bottomLeftResize)"
    (touchstart)="onCornerTouchStart($event, bottomLeftResize)"
    id="box-bottom-left-resize"
    class="box-corner-resize resize-action"
  ></div>
  <div
    (mousedown)="onCornerClick($event, bottomRightResize)"
    (touchstart)="onCornerTouchStart($event, bottomRightResize)"
    id="box-bottom-right-resize"
    class="box-corner-resize resize-action"
  ></div>
</div>